(() => {
  if (window.NordfreskSaleTimerInitialized) return;

  window.NordfreskSaleTimerInitialized = true;

  const pad = (value) => String(value).padStart(2, '0');

  const updateTimers = () => {
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const remaining = Math.max(0, Math.floor((end - now) / 1000));
    const hours = pad(Math.floor(remaining / 3600));
    const minutes = pad(Math.floor((remaining % 3600) / 60));
    const seconds = pad(remaining % 60);

    document.querySelectorAll('[data-nordfresk-sale-timer]').forEach((timer) => {
      const hoursElement = timer.querySelector('[data-nordfresk-sale-hours]');
      const minutesElement = timer.querySelector('[data-nordfresk-sale-minutes]');
      const secondsElement = timer.querySelector('[data-nordfresk-sale-seconds]');

      if (hoursElement) hoursElement.textContent = hours;
      if (minutesElement) minutesElement.textContent = minutes;
      if (secondsElement) secondsElement.textContent = seconds;
    });
  };

  updateTimers();
  window.setInterval(updateTimers, 1000);
})();
